import { InventoryViews, DefaultInventoryOption } from '@/enums/modules/inventory'
import { sortableFields } from '@/models/inventory/tableDefinition'
import { objectToArray } from '@/utils/dataStructureConverter'

import { RouteValidatorBuilder } from '@/utils/routeValidator'

import {
  SearchFilter
} from '@/models/returns/filterDefinitions'

const baseSupportedViews = objectToArray(InventoryViews, (obj, key) => obj[key])
const baseSupportedOptions = objectToArray(DefaultInventoryOption, (obj, key) => obj[key])
const SUPPORTED_FILTER_TYPES = [
  SearchFilter
].map(f => f.filterType)

const routeValidatorCreator = (obj = []) => new RouteValidatorBuilder()
  .withDefaultView(InventoryViews.AllView)
  .withSupportedViews(baseSupportedViews.concat(obj.fcs))
  .withDefaultOption(DefaultInventoryOption.active)
  .withSupportedOptions(baseSupportedOptions.concat(obj.options))
  .withDefaultPageNumber(1)
  .withDefaultPageSize(25)
  .withSupportedFilterTypes(SUPPORTED_FILTER_TYPES)
  .withSortableFields(sortableFields)
  .toValidator()

const routeStatusValidatorCreator = (obj = []) => new RouteValidatorBuilder()
  .withDefaultView(InventoryViews.OnHand)
  .withSupportedViews(baseSupportedViews.concat(obj.status))
  .withDefaultOption(DefaultInventoryOption.active)
  .withSupportedOptions(baseSupportedOptions.concat(obj.options))
  .withDefaultPageNumber(1)
  .withDefaultPageSize(25)
  .withSupportedFilterTypes(SUPPORTED_FILTER_TYPES)
  .withSortableFields(sortableFields)
  .toValidator()

class RouteValidator {
  constructor () {
    this.validator = routeValidatorCreator()
  }

  configureFulfillmentCenters (obj) {
    this.validator = routeValidatorCreator(obj)
  }

  configureStatus (obj) {
    this.validator = routeStatusValidatorCreator(obj)
  }

  validateRoute (route) {
    return this.validator(route)
  }
}

export const InventoryRouteValidator = new RouteValidator()
